import Vue from 'vue'
import Router from 'vue-router'
import allRoutes from './router'
import Utils, { getFirstMenuRoute } from '../libs/utils'
import store from '@/store'
import { isRouteAuthorized } from '@/libs/menuPermission'

Vue.use(Router)

const baseRoutes = allRoutes.filter(route => route.path !== '*' && !(route.meta && route.meta.requireAuth))
const notFoundRoute = allRoutes.find(route => route.path === '*')

const RouterConfig = {
  // mode: 'history',
  routes: baseRoutes
};

function createRouter() {
  return new Router(RouterConfig)
}

export const router = createRouter();

function getToken() {
  return localStorage.getItem('token') || ''
}

function isLoginRoute(route) {
  return route && route.name === 'login'
}

function isAuthPagePath(path) {
  return /^\/(login|register|forgetPassword|404)(?:[/?#]|$)/.test(String(path || ''))
}

function normalizeRedirectPath(value) {
  if (!value || typeof value !== 'string') return ''
  let path = value
  try {
    path = decodeURIComponent(path)
  } catch (error) {
    path = value
  }
  return path.replace(/^#/, '')
}

function requiresAuth(route) {
  return route.matched.some(item => item.meta && item.meta.requireAuth)
}

function getMenuRouteTarget(menuRoute) {
  if (!menuRoute) return null
  if (menuRoute.fullPath) return { path: menuRoute.fullPath }
  if (menuRoute.path && menuRoute.path.charAt(0) === '/') return { path: menuRoute.path }
  return menuRoute.name ? { name: menuRoute.name } : null
}

function isMenuRouteAvailable(menuRoute) {
  const target = getMenuRouteTarget(menuRoute)
  if (!target) return false
  const matchedRoute = router.match(target)
  return Boolean(
    matchedRoute &&
    matchedRoute.name &&
    matchedRoute.name !== 'NotFound' &&
    matchedRoute.matched &&
    matchedRoute.matched.length &&
    isRouteAuthorized(matchedRoute, store.getters.menuAccess)
  )
}

export function getDefaultRoute() {
  const firstMenuRoute = getFirstMenuRoute(store.getters.menuList, isMenuRouteAvailable)
  return getMenuRouteTarget(firstMenuRoute)
}

function addDynamicRoutes() {
  if (store.state.user.routeAdded) return
  const routes = store.getters.dynamicRoutes || []
  router.addRoutes(notFoundRoute ? routes.concat([notFoundRoute]) : routes)
  store.commit('setDynamicRoutesAdded', true)
}

export function ensureDynamicRoutes() {
  addDynamicRoutes()
}

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  store.commit('setDynamicRoutesAdded', false)
}

function goLogin(to, next) {
  const redirectPath = to && to.fullPath && !isAuthPagePath(to.fullPath) ? to.fullPath : ''
  next({
    name: 'login',
    replace: true,
    query: redirectPath ? { redirect: redirectPath } : {}
  })
}

function resolveAfterMenus(to, next) {
  addDynamicRoutes()

  if (to.path === '/') {
    const defaultRoute = getDefaultRoute()
    if (defaultRoute) {
      next(Object.assign({}, defaultRoute, { replace: true }))
      return true
    }
    next({ name: 'NotFound', replace: true })
    return true
  }

  if (to.name === 'login') {
    const defaultRoute = getDefaultRoute()
    if (defaultRoute) {
      next(Object.assign({}, defaultRoute, { replace: true }))
      return true
    }
  }

  if (!to.matched.length) {
    const matchedRoute = router.match(to.fullPath || to.path)
    if (matchedRoute && matchedRoute.matched && matchedRoute.matched.length) {
      next({
        path: to.fullPath || to.path,
        replace: true
      })
      return true
    }
    next({ name: 'NotFound', replace: true })
    return true
  }

  if (requiresAuth(to) && !isRouteAuthorized(to, store.getters.menuAccess)) {
    next({ name: 'NotFound', replace: true })
    return true
  }

  return false
}

router.beforeEach((to, from, next) => {
  const token = getToken()

  if (isLoginRoute(to)) {
    const redirectPath = normalizeRedirectPath(to.query && to.query.redirect)
    if (redirectPath && isAuthPagePath(redirectPath)) {
      next({ name: 'login', replace: true })
      return
    }
    Utils.title(to.meta.title)
    next()
    return
  }

  if (to.path === '/' && !token) {
    next({ name: 'login', replace: true })
    return
  }

  if (!token && (requiresAuth(to) || !to.matched.length)) {
    goLogin(to, next)
    return
  }

  if (token && (to.path === '/' || to.name === 'login' || requiresAuth(to) || !to.matched.length)) {
    store.dispatch('loadUserMenus').then(() => {
      if (resolveAfterMenus(to, next)) return
      Utils.title(to.meta.title)
      next()
    }).catch(() => {
      if (to.name === 'login') {
        next()
        return
      }
      goLogin(to, next)
    })
    return
  }

  Utils.title(to.meta.title)
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js